<template>
    <div>
        <img class="education-banner" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/education-banner.png" alt="">
        <div class="link-box">
            <div class="link-box-title">覆盖教育机构全部经营环节</div>
            <div class="link-box-title2">提供全方位解决方案 </div>
            <div class="link-boxCont">
                <div @click="goeducationRecruit" class="link-circularBG" style="z-index: 1;">
                    <img class="link-half-arc arc-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/half-arc.png" alt="">
                    <img class="link-half-arc arc-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/half-arc-r.png" alt="">
                    <div class="link-circular">
                        <img class="link-circularImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/education-link2.png" alt="">
                        <div class="link-circularText">智能营销</div>
                    </div>
                    <div class="link-circular-Info">
                        <div class="link-circular-InfoLink"></div>
                        <div class="link-circular-InfoNum">
                            <span>1</span>
                            <div class="link-circular-InfoNumLin"></div>
                            <div class="link-circular-InfoC">
                                <div class="link-circular-InfoC-title">智能营销</div>
                                <div class="link-circular-InfoC-title2">多种营销工具帮助教育机构获取、</div>
                                <div class="link-circular-InfoC-title2">分析、孵化潜在客户，提高转化率。</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div @click="goeducationTeaching" class="link-circularBG link-circularBG2">
                    <img class="link-half-arc arc-show" style="transform: rotate(180deg);top: 0;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/half-arc.png" alt="">
                    <img class="link-half-arc arc-show2" style="transform: rotate(180deg);top: 0;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/half-arc-r.png" alt="">
                    <div class="link-circular">
                        <img class="link-circularImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/education-link1.png" alt="">
                        <div class="link-circularText">智能教学</div>
                    </div>
                    <div class="link-circular-Info2">
                        <div class="link-circular-InfoLink"></div>
                        <div class="link-circular-InfoNum">
                            <span>2</span>
                            <div class="link-circular-InfoNumLin"></div>
                            <div class="link-circular-InfoC">
                                <div class="link-circular-InfoC-title">智能教学</div>
                                <div class="link-circular-InfoC-title2">提供课前、课中、课后全方位服务支持，</div>
                                <div class="link-circular-InfoC-title2">减轻教师工作压力，提高学生学习成绩。</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div @click="goeducationAdministration" class="link-circularBG link-circularBG3">
                    <img class="link-half-arc arc-show"  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/half-arc.png" alt="">
                    <img class="link-half-arc arc-show2"  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/half-arc-r.png" alt="">
                    <div class="link-circular">
                        <img class="link-circularImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/education-link3.png" alt="">
                        <div class="link-circularText">智能管理</div>
                    </div>
                    <div class="link-circular-Info">
                        <div class="link-circular-InfoLink"></div>
                        <div class="link-circular-InfoNum">
                            <span>3</span>
                            <div class="link-circular-InfoNumLin"></div>
                            <div class="link-circular-InfoC">
                                <div class="link-circular-InfoC-title">智能管理</div>
                                <div class="link-circular-InfoC-title2">提升机构办公效率，节省办公开支；</div>
                                <div class="link-circular-InfoC-title2">整合内部管理流程，提高管理质量。</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="education-info">
            <div class="education-infoL">
                <div class="education-infoL-title">智能招生解决方案</div>
                <div class="education-infoL-title2">打造企业私域流量池，解决获客转化难题</div>
                <div class="education-infoL-title2">推动销售业绩全面提升</div>
                <div class="education-infoL-title3">招生拓客：营销工具助力获取更多流量</div>
                <div class="education-infoL-title3">线索管理：线索管理提高线索转化率</div>
                <div class="education-infoL-title3">智能分析：数据分析实现精准营销，提升营销效率</div>
                <div @click="goeducationRecruit" class="education-infoBtn" style="margin-top: 50px;">
                    <img class="arrow" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/arrow.png" alt="">
                </div>
            </div>
            <div class="education-infoR">
                <img  class="education-introduce1" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/education-introduce1.png" alt="">
            </div>
        </div>
        <div class="education-info">
            <div class="education-infoL">
                <img class="education-introduce2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/education-introduce2.png" alt="">
            </div>
            <div class="education-infoR" style="box-sizing: border-box;padding-left: 165px;">
                <div class="education-infoL-title">智能教学解决方案</div>
                <div class="education-infoL-title2">教师轻松教学，学生高效学习</div>
                <div class="education-infoL-title3">课前备课：课前备课一键调取，实现轻松备课</div>
                <div class="education-infoL-title3">课堂互动：多种互动工具帮助提升课堂效率，提升学习兴趣</div>
                <div class="education-infoL-title3">课后检测：督学系统及时掌握学生动态，多维度分析数据测试</div>
                <div class="education-infoL-title3">结果，辅助教师教学</div>
                <div @click="goeducationTeaching" class="education-infoBtn" style="margin-top: 50px;">
                    <img class="arrow" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/arrow.png" alt="">
                </div>
            </div>
        </div>
        <div class="education-info" style="margin-bottom: 100px;">
            <div class="education-infoL">
                <div class="education-infoL-title">智能管理解决方案</div>
                <div class="education-infoL-title2">降低管理成本，提升管理效率</div>
                <div class="education-infoL-title3">提升学校办公效率，节省办公开支</div>
                <div class="education-infoL-title3">整合内部管理流程，提升学校管理质量；</div>
                <div @click="goeducationAdministration" class="education-infoBtn" style="margin-top: 50px;">
                    <img class="arrow" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/arrow.png" alt="">
                </div>
            </div>
            <div class="education-infoR">
                <img class="education-introduce3" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/education-introduce3.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "education",
        methods:{
            goeducationAdministration(){
                this.$router.push('/educationAdministration')
            },
            goeducationTeaching(){
                this.$router.push('/educationTeaching')
            },
            goeducationRecruit(){
                this.$router.push('/educationRecruit')
            },
        }
    }
</script>

<style lang="less" scoped>
    .education-banner{
        width: 100%;
        margin-top: 7px;
    }

    .link-box{
        width: 100%;
        height: 895px;
        background: #f8faff;
        box-sizing: border-box;
        padding-top: 60px;
        .link-box-title{
            font-size: 32px;
            font-weight: bold;
            color: #000;
            text-align: center;
        }
        .link-box-title2{
            font-size: 32px;
            color: #000;
            text-align: center;
            margin-top: 20px;
            margin-bottom: 150px;
        }
        .link-boxCont{
            width: 1200px;
            margin: 0 auto;
            display: flex;
            .link-circularBG{
                cursor: pointer;
                width: 400px;
                height: 400px;
                -webkit-border-radius: 100%;
                -moz-border-radius: 100%;
                border-radius: 100%;
                /*border: 5px solid #DC0616;*/
                /*border: 5px solid #E5EEFF;*/
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                .link-half-arc{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                }
                .arc-show{
                    display: block;
                }

                .arc-show2{
                    display: none;
                }
                .link-circular{
                    width: 273px;
                    height: 273px;
                    background: #E4ECFF;
                    -webkit-border-radius: 100%;
                    -moz-border-radius: 100%;
                    border-radius: 100%;
                    position: relative;
                    z-index: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .link-circularImg{
                        margin-bottom: 24px;
                    }
                    .link-circularText{
                        font-size: 18px;
                        font-weight: bold;
                        color: #586480;
                    }
                }
                .link-circular-Info{
                    position: absolute;
                    bottom: -88px;
                    display: none;
                    .link-circular-InfoLink{
                        width: 2px;
                        height: 51px;
                        background: #DC0616;
                    }
                    .link-circular-InfoNum{
                        width: 37px;
                        height: 37px;
                        background: #DC0616;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 28px;
                        color: #FFFFFF;
                        position: relative;
                        .link-circular-InfoNumLin{
                            width: 40px;
                            height: 2px;
                            background: #DC0616;
                            position: absolute;
                            right: -38px;
                            bottom: 10px;
                        }
                        .link-circular-InfoC{
                            position: absolute;
                            right: -348px;
                            top: 5px;
                            width: 300px;
                            .link-circular-InfoC-title{
                                font-size: 28px;
                                color: #DC0616;
                                margin-bottom: 10px;
                            }
                            .link-circular-InfoC-title2{
                                font-size: 16px;
                                color: #000;
                            }
                        }
                    }
                }
                .link-circular-Info2{
                    position: absolute;
                    top: -88px;
                    display: none;
                    .link-circular-InfoLink{
                        width: 2px;
                        height: 88px;
                        background: #DC0616;
                    }
                    .link-circular-InfoNum{
                        width: 37px;
                        height: 37px;
                        background: #DC0616;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 28px;
                        color: #FFFFFF;
                        position: absolute;
                        top: 0;
                        .link-circular-InfoNumLin{
                            width: 40px;
                            height: 2px;
                            background: #DC0616;
                            position: absolute;
                            right: -38px;
                            bottom: 10px;
                        }
                        .link-circular-InfoC{
                            position: absolute;
                            right: -348px;
                            top: 5px;
                            width: 300px;
                            .link-circular-InfoC-title{
                                font-size: 28px;
                                color: #DC0616;
                                margin-bottom: 10px;
                            }
                            .link-circular-InfoC-title2{
                                font-size: 16px;
                                color: #000;
                            }
                        }
                    }
                }
            }
            .link-circularBG2{
                position: relative;
                left: -3px;
            }
            .link-circularBG3{
                position: relative;
                left: -6px;
            }
            .link-circularBG:hover .link-circular-Info{
                /*border: 5px solid #DC0616;*/
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .link-circularBG:hover .link-circular-Info2{
                /*border: 5px solid #DC0616;*/
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .link-circularBG:hover .link-circular{
                background: rgba(220,6,22,.1);
            }
            .link-circularBG:hover .link-circularText{
                color: #DC0616;
            }
            .link-circularBG:hover .arc-show{
                display: none;
                z-index: 1;
            }
            .link-circularBG:hover .arc-show2{
                display: block;
                z-index: 1;
            }
        }

    }

    .education-info{
        width: 1200px;
        margin: 35px auto 0 auto;
        display: flex;
        position: relative;
        .education-infoL{
            .education-infoL-title{
                font-size: 28px;
                font-weight: 800;
                margin-top: 100px;
                margin-bottom: 40px;
            }
            .education-infoL-title2{
                font-size: 24px;
                margin-bottom: 20px;
            }
            .education-infoL-title3{
                font-size: 16px;
                color: #0A0A0A;
                margin-bottom: 10px;
            }

        }
        .education-infoBtn{
            width: 54px;
            height: 54px;
            background: #DC0616;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .arrow{
                width: 22px;
                cursor: pointer;
            }
        }
        .education-infoBtn:hover{
            box-shadow:1px 1px 6px 3px rgba(220,6,22,.5);
        }
        .education-infoR{
            .education-infoL-title{
                font-size: 28px;
                font-weight: 800;
                margin-top: 100px;
                margin-bottom: 40px;
            }
            .education-infoL-title2{
                font-size: 24px;
                margin-bottom: 20px;
            }
            .education-infoL-title3{
                font-size: 16px;
                color: #0A0A0A;
                margin-bottom: 10px;
            }
            .education-introduce1{
                position: absolute;
                top: 0;
                right: 0;
            }
            .education-introduce3{
                padding-left: 341px;
            }
        }
    }
</style>